<template>
  <section>
    <form v-if="resumeRender" @submit.prevent="submit" class="fuid-border-bottom">
      <b-row>
        <b-col cols="12" class="fuid-form-to-render">
          <h4 class="fuid-resu-tit">{{ $t("resume.tit1") }}</h4>

          <div v-for="(alumno, index) in getNuevos" :key="index" class="fuid-resu__pupilc">
            <b-row>
              <b-col cols="12" lg="2" class="fuid-resu__pupil">
                <h4>{{ $t("resume.alumno") }} {{ index + 1 }}</h4>
              </b-col>

              <b-col cols="12" lg="9">
                <div class="d-flex">
                  <div v-if="alumno.nombre" class="fuid-resu__pupildata">
                    <span>{{ $t("forms.student.nombre") }}</span><strong>{{ alumno.nombre }}</strong>
                  </div>
                  <div v-if="alumno.apellidos" class="fuid-resu__pupildata">
                    <span>{{ $t("forms.student.apellidos") }}</span><strong>{{ alumno.apellidos }}</strong>
                  </div>
                </div>

                <div class="d-lg-flex">
                  <div v-if="alumno.dni" class="fuid-resu__pupildata">
                    <span>{{ $t("forms.student.dni") }}</span><strong>{{ alumno.dni }}</strong>
                  </div>
                  <div v-if="alumno.telefono" class="fuid-resu__pupildata">
                    <span>{{ $t("forms.student.telefono") }}</span><strong>{{ alumno.telefono }}</strong>
                  </div>
                  <div v-if="alumno.fechaNacimiento" class="fuid-resu__pupildata">
                    <span>{{ $t("forms.student.nacimiento") }}</span><strong>{{ getBirthDate(alumno.fechaNacimiento)
                    }}</strong>
                  </div>

                  <div class="fuid-resu__pupildata">
                    <span>{{ $t("resume.idiomas") }}</span>
                    <strong>{{ getLanguageByAlumnoId(alumno.id) }}</strong>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <div v-for="(alumno, index) in getAntiguos" :key="index" class="fuid-resu__pupilc">
            <b-row>
              <b-col cols="12" lg="2" class="fuid-resu__pupil">
                <h4>{{ $t(('resume.alumno')) }} {{ getNuevos.length + index + 1 }}</h4>
              </b-col>
              <b-col cols="12" lg="9">
                <div v-if="alumno.codigo" class="fuid-resu__pupildata">
                  <span>{{ $t('forms.student.codigo') }}</span><strong>{{ alumno.codigo }}</strong>
                </div>
                <div class="fuid-resu__pupildata">
                  <span>{{ $t('resume.idiomas') }}</span>
                  <strong>{{ getLanguageByAlumnoId(alumno.id) }}</strong>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="getSolicitante" class="fuid-form-to-render">
        <b-col cols="12">
          <h4 class="fuid-resu-tit">
            {{ $t("resume.tit2") }}
            <span class="fuid-resu-tit-data">({{ $t("tabs.2sub") }})</span>:
          </h4>
        </b-col>

        <b-col cols="12" class="fuid-resu__soli">
          <b-row>
            <b-col v-if="getSolicitante.dni" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("resume.dni") }}</span>
              <strong>{{ getSolicitante.dni }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.nombre" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.student.nombre") }}</span>
              <strong>{{ getSolicitante.nombre }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.telefono" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.student.telefono") }}</span>
              <strong>{{ getSolicitante.telefono }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.email" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.student.email") }}</span>
              <strong>{{ getSolicitante.email }}</strong>
            </b-col>
          </b-row>

          <b-row>
            <b-col v-if="getSolicitante.codigoPostal" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.applicant.cp") }}</span>
              <strong>{{ getSolicitante.codigoPostal }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.colegio" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.applicant.colegio") }}</span>
              <strong>{{ getSolicitante.colegio }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.empresa" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.applicant.empresa") }}</span>
              <strong>{{ getSolicitante.empresa }}</strong>
            </b-col>

            <b-col v-if="getSolicitante.forma" cols="12" lg="3" class="fuid-resu__pupildata">
              <span>{{ $t("forms.applicant.como") }}</span>
              <strong>{{ getForma(getSolicitante.forma) }} </strong>
              <span class="fuid-resu__friend" v-if="getSolicitante.forma == 1 && getSolicitante.amigo != null">{{
                $t("forms.applicant.amigo") }}:
                {{ getSolicitante.amigo }}</span>
              <span class="fuid-resu__friend" v-if="getSolicitante.forma == 1 && getSolicitante.amigoAlt != null
                ">{{ $t("forms.applicant.amigo") }}:
                {{ getSolicitante.amigoAlt }}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="fuid-form-group fuid-form-group__1mb fuid-form-group__1pb"
          :class="{ 'form-group--error': $v.fields.veracity.$error }">
          <div class="fuid-chra-box nmb d-inline-block mb-4 mb-lg-0">
            <input type="checkbox" id="veracity" name="veracity" v-model.trim="$v.fields.veracity.$model" />
            <label for="veracity" class="d-flex align-items-start align-items-lg-center">{{ $t("resume.veracity")
            }}</label>

            <div class="error-c error" v-if="!$v.fields.veracity.required">
              {{ $t("forms.required") }}
            </div>
            <div class="error-c error" v-if="!$v.fields.veracity.boo">
              {{ $t("forms.required") }}
            </div>
          </div>
        </b-col>

        <b-col cols="12" class="fuid-form-group fuid-form-group__1mb fuid-form-group__1pb"
          :class="{ 'form-group--error': $v.fields.privacy.$error }">
          <div class="fuid-chra-box nmb d-inline-block mb-4 mb-lg-0">
            <input type="checkbox" id="privacy" name="privacy" v-model.trim="$v.fields.privacy.$model" />
            <label for="privacy" class="d-flex align-items-start align-items-lg-center">{{ $t("resume.privacy") }}</label>

            <div class="error-c error" v-if="!$v.fields.privacy.required">
              {{ $t("forms.required") }}
            </div>
            <div class="error-c error" v-if="!$v.fields.privacy.boo">
              {{ $t("forms.required") }}
            </div>
          </div>
        </b-col>
      </b-row>
    </form>

    <div v-else>
      <b-row class="fuid-resu__result fuid-resu__soli">
        <b-col v-if="prematriculaOk" cols="12">
          <h4 class="fuid-resu-tit">{{ $t("resume.titok") }}</h4>
          <p class="fuid-resu__txtok fuid-resu__txtokid">
            {{ $t("resume.id") }} <strong>{{ prematriculaId }}</strong>
          </p>
          <p class="fuid-resu__txtok">{{ $t("resume.txtok") }}</p>
        </b-col>

        <b-col v-else cols="12">
          <h4 class="fuid-resu-tit text-center">{{ $t("resume.titerror") }}</h4>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
// ----------------------------------------------------------
// To map shit from Vuex
// ----------------------------------------------------------
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import { required } from "vuelidate/lib/validators";
import boo from "@/mixins/validatorBoolean";

export default {
  props: {
    localizacion: {
      type: Number,
      default: 0,
      required: true,
    },
  },

  data() {
    return {
      resumeRender: true,
      prematricula: null,
      prematriculaId: null,
      prematriculaOk: false,
      fields: {
        veracity: false,
        privacy: false,
      },
    };
  },

  validations: {
    fields: {
      privacy: {
        required,
        boo,
      },

      veracity: {
        required,
        boo,
      },
    },
  },

  computed: {
    ...mapGetters("Personas", ["getNuevos"]),
    ...mapGetters('Personas', ['getAntiguos']),
    ...mapGetters("Personas", ["getSolicitante"]),
    ...mapGetters("Personas", ["getFormas"]),
    ...mapGetters("Prematricula", ["getLanguagesForAlumno"]),
    ...mapGetters("Prematricula", ["getPrematricula"]),
    ...mapGetters("Localizaciones", ["getIdiomasCode"]),
    ...mapGetters("Localizaciones", ["getLocalizacion"]),

    antiguos() {
      return this.getNuevos();
    },

    getLanguage() {
      let language;

      switch (this.$i18n.locale) {
        case "es":
          language = 1;

          break;

        case "eu":
          language = 2;

          break;

        default:
          language = 1;
      }

      return language;
    },
  },

  methods: {
    /**
     * Map actions from Vuex
     *
     */

    ...mapActions("Prematricula", ["postPrematricula"]),
    ...mapActions("Prematricula", ["setField"]),

    async submit() {
      this.$emit("sendPrematricula", {
        value: true,
      });

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.validation_form = false;
      } else {
        this.validation_form = true;
      }

      this.setField({ language: this.getLanguage });
      this.setField({ localizacion: this.localizacion });

      if (this.validation_form) {
        // Check prematricula fase depending on dates
        let d = new Date();
        if (this.getLocalizacion[0].ultimoCurso.fechaInicioPrematriculaFase3.split('T')[0] <= d.toISOString().split('T')[0]) {
          this.getPrematricula.fase = 3;
        }

        this.prematricula = await this.postPrematricula();

        if (this.prematricula && this.prematricula.statusText === "Created") {
          this.prematriculaId = this.prematricula.data.orden;
          this.prematriculaOk = true;
          this.track();
        } else {
          this.prematriculaOk = false;
          this.$emit("sendPrematricula", {
            value: false,
          });
        }

        this.resumeRender = false;

        this.$emit("getPrematricula", {
          valid: this.prematriculaOk,
        });
      }

      this.$emit("sendPrematricula", {
        value: false,
      });
    },

    getBirthDate(date) {
      let dd = new Date(date);

      let d = dd.getDate();
      let m = this.$i18n.t(`forms.months.${dd.getMonth() + 1}`);
      let y = dd.getFullYear();

      return d + " " + m + " " + y;
    },

    getLanguageByAlumnoId(id) {
      let langs = this.getLanguagesForAlumno(id);
      let langString = "";

      langs.forEach((a) => {
        langString += this.$i18n.t(
          `languages.${this.getIdiomasCode(a.idioma)}`
        );
        langString += " ";
      });

      return langString;
    },

    getForma(code) {
      let formas = this.getFormas;

      let forma = formas.filter(function (forma) {
        return forma.id == code;
      });

      return this.$i18n.t(`formas.${forma[0].codigoTraduccion}`);
    },

    track() {
      this.$gtag.event("conversion", {
        send_to: "AW-857852491/M8wtCOqZ99MBEMuUh5kD",
        event_callback: null,
      });
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/resume";
</style>
